export const projectApiUrl = {
  getProjects: "/project",
  updateProject: "/project/update",
};
